import { Component, OnInit, ViewChild } from '@angular/core';
import { Store } from '@ngrx/store';
import { Router, ActivatedRoute } from '@angular/router';
import { Broker, Platform } from '@c4/core';
import { AuthenticationService } from '@c4/auth';
import { Observable } from 'rxjs';

import { SysmanComponentBase, IOnBrokerConnectedInit } from '../sysman/sysman.component';

import { ConnectedDeviceService, NetworkService, VersionsService } from '../services';

@Component({
  selector: 'sysman-sddp-device-detail',
  templateUrl: './sysman-sddp-device-detail.component.html',
  styleUrls: ['./sysman-sddp-device-detail.component.less']
})
export class SysmanSddpDeviceDetailComponent extends SysmanComponentBase implements OnInit, IOnBrokerConnectedInit {

  activeNetwork: any;
  allNetworkInterfaces: Array<any>;
  waitMsg: string = "";
  waitMsgBtn: string = "";
  returnToDiscoveryPage: boolean = false;

  private showRebootModal = false;
  private showPleaseWaitModal = false;

  constructor(private store: Store<any>, private router: Router, private route: ActivatedRoute,
    private broker: Broker, private platform: Platform,
    private connectedDeviceService: ConnectedDeviceService,
    private networkService: NetworkService,
    private versionsService: VersionsService,
    private auth: AuthenticationService) {
    super(router, route, store, broker, platform, connectedDeviceService, versionsService);
    super.setBrokerInit(this.onBrokerConnectedInit); // method to call on broker init
    this.allNetworkInterfaces = [];
    this.activeNetwork = {};
  }

  ngOnInit() {
    super.OnInit();
  }

  ngOnDestroy() {
    super.destroy();
    this.activeNetwork = {};
    this.allNetworkInterfaces = [];
  }

  onBrokerConnectedInit() {
    this.connDevice.take(1).subscribe(conn => this.getEnabledNetwork(((this.brokerHost != conn.connectedDevice.address) ? conn.connectedDevice.address : null)));

    this.subscriptions.push(
      this.broker.connected.skip(1).subscribe(
        (data: any) => {
          this.showPleaseWaitModal = false;

          // refresh network settings after reboot
          console.log("SysmanSddpDeviceDetailComponent: Rebooting after network change - CONNECTED");
          this.connDevice.take(1).subscribe(conn => this.getEnabledNetwork(((this.brokerHost != conn.connectedDevice.address) ? conn.connectedDevice.address : null)));
        },
        (err: any) => console.error('SysmanSddpDeviceDetailComponent: broker event for connected error', err))
    );
  }

  onClickConfigureNetwork() {
    this.router.navigate(['../../sysman/network'], { relativeTo: this.route });
  }

  goBack() {
    this.router.navigate(['../../sysman/disco'], { relativeTo: this.route });
  }

  getEnabledNetwork(ip?: string) {
    this.connectedDeviceService.setWorking(true);
    this.networkService.getNetworkInfo(ip).then(
      (data: any) => {
        console.log('in getEnabledNetwork()', data);
        this.connectedDeviceService.setWorking(false);
        this.allNetworkInterfaces = data;
        if (Array.isArray(data)) {
          var networks = data.filter(network => {
            return (network.enabled == 1)
          }
          );
          if (networks.length > 0) {
            this.activeNetwork = networks[0];
          }
        }
      },
      (err: any) => {
        console.error('getEnabledNetwork() error: ', err);
        this.connectedDeviceService.setWorking(false);
      }
    );
  }

  getStatusClass(isOK:boolean) { 
    if (isOK)
      return "status-online";
    else
      return "status-offline";
  }

  reboot() {
    this.connectedDeviceService.setWorking(false);
    this.showRebootModal = false;

    this.connDevice.take(1).subscribe(conn => {  
      // if rebooting broker host then wait until reconnection
      if (conn.connectedDevice && (this.brokerHost == conn.connectedDevice.address)) {
        this.returnToDiscoveryPage = false;
        this.waitMsgBtn = "";
        this.waitMsg = "Please wait while your controller reboots. You will be redirected.";
        // display modal for 5 seconds then go back to dashboard
        setTimeout(o => {
            this.router.navigate(['/']);
        }, 5000);
      }
      else { // if we are connecting to a slave then redirect back to discovery page
        this.returnToDiscoveryPage = true;
        this.waitMsgBtn = "OK";
        this.waitMsg = "The device is rebooting. Click OK to return to the Discovery page.";
      }
      this.showPleaseWaitModal = true;

      let address = null;
      if (conn.connectedDevice)
        address = conn.connectedDevice.address;

      this.networkService.rebootDevice(((this.brokerHost != address) ? address : null)).then(
        (data: any) => {
          console.error('reboot() data: ', data);
        },
        (err: any) => {
          console.error('reboot() error: ', err);
        });
    });
  }

  onClickPleaseWaitCancel() {
    this.showPleaseWaitModal = false;

    if (this.returnToDiscoveryPage) { // reset connection to broker host
      this.platform.getPlatformStatus().then(
        (result: any) => {
          this.returnToDiscoveryPage = false;
          let directorVersion = this.getDirectorVersion(result);
          this.connectedDeviceService.setConnection({ uuid: result.directorUUID, address: this.brokerHost, directorName: result.directorName, version: directorVersion });
          this.router.navigate(["../../sysman/disco"], { relativeTo: this.route });
        },
        (err: any) => {
          console.log('in onClickPleaseWaitCancel.getPlatformStatus() error', err);
        });
    }
  }

}



// WEBPACK FOOTER //
// ./~/@c4/sysman/src/app/sysman-sddp-device-detail/sysman-sddp-device-detail.component.ts